export default {
  'return': {key: 'return', value: 'Return', past: 'Returned'},
  'cancel': {key: 'cancel', value: 'Cancel',  past: 'Cancelled'},
  'receive': {key: 'receive', value: 'Receive', past: 'Received'},
  'newPo': {key: 'newPo', value: 'New PO', past: 'New PO'},
  'manualQuote': {key: 'manualQuote', value: 'Manual Quote', past: 'Manual Quote'}
  }